export default __webpack_public_path__ + "static/media/Campuzano.6f7d17a6.jpg";